// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid.questions {
  grid-template-columns: repeat(2, auto);
}
.notes-section {
  max-width: 100%;
  margin: 15px;
}
.save-btn {
  margin-left: 15px !important;
}
.docs-wrapper {
  width: 100% !important;
}
mat-slide-toggle {
  margin: 0;
}
.modal-body .form-row {
  margin: 8px 0;
}
.grid.applicantData {
  width: 100%;
  grid-template-columns: repeat(6, auto);
}
.modal-header {
  background-color: #0f1a35;
  color: white !important;
}
.modal-header .modal-title {
  font-size: 20px !important;
  font-weight: 600;
}
.modal-header .close {
  color: red;
  text-shadow: none;
  opacity: 1;
  font-size: 26px;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none;
  background: transparent;
}
.modal-footer {
  padding: 2px !important;
}
.grid.verificationData {
  width: 100%;
  grid-template-columns: repeat(8, auto);
}
h2.filter-title {
  width: 100%;
  display: block;
  text-align: center;
  background: #bfc3ce;
}
.table-wrapper {
  padding: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/residence-verification-form/residence-verification-form.component.less"],"names":[],"mappings":"AAEA;EACI,sCAAA;AADJ;AAIA;EACI,eAAA;EACA,YAAA;AAFJ;AAKA;EACI,4BAAA;AAHJ;AAMA;EACI,sBAAA;AAJJ;AAOA;EACE,SAAA;AALF;AAOA;EACI,aAAA;AALJ;AAQA;EACI,WAAA;EACA,sCAAA;AANJ;AASA;EACI,yBAAA;EACA,uBAAA;AAPJ;AAKA;EAKO,0BAAA;EACA,gBAAA;AAPP;AACA;EASO,UAAA;EACC,iBAAA;EACA,UAAA;EACD,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;AAPP;AAWA;EACI,uBAAA;AATJ;AAaA;EACI,WAAA;EACA,sCAAA;AAXJ;AAcA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAZJ;AAeA;EAAgB,qBAAA;AAZhB","sourcesContent":["@import (reference) url('../../../styles.less');\n\n.grid.questions {\n    grid-template-columns: repeat(2, auto);\n}\n\n.notes-section {\n    max-width: 100%;\n    margin: 15px;\n}\n\n.save-btn {\n    margin-left: 15px !important;\n}\n\n.docs-wrapper {\n    width: 100% !important;\n}\n\nmat-slide-toggle {\n  margin: 0;\n}\n.modal-body .form-row{\n    margin: 8px 0;\n}\n\n.grid.applicantData {\n    width:100%;\n    grid-template-columns: repeat(6, auto);\n}\n\n.modal-header{\n    background-color: #0f1a35;\n    color: white !important;\n    \n    .modal-title{\n       font-size: 20px !important;\n       font-weight: 600;\n    };\n    .close{\n       color: red;\n        text-shadow: none;\n        opacity: 1;\n       font-size: 26px;\n       padding: 0 !important;\n       margin : 0 !important;\n       box-shadow: none;\n       background: transparent;\n    }\n}\n\n.modal-footer{\n    padding: 2px !important;\n}\n\n\n.grid.verificationData {\n    width:100%;\n    grid-template-columns: repeat(8, auto);\n}\n\nh2.filter-title{\n    width:100%;\n    display:block;\n    text-align: center;\n    background: #bfc3ce;\n}\n\n.table-wrapper{ padding: 0 !important;}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
